module.exports = __webpack_public_path__ + "assets/img/capabilities_img1.35ee9102.png";